
      const base = import.meta.env.BASE_URL || '/';
      try {
        const res = await fetch(`${base}config.json`, { cache: 'no-store' });
        if (!res.ok) throw new Error(`config.json ${res.status}`);
        window.__APP_CONFIG__ = await res.json();
      } catch (e) {
        console.error('Failed to load config.json', e);
      }
    